import { EmailBlast } from '../model/EmailBlast.js';
import styles from './EmailPreview.module.css';
import { PostContentsToHTML } from './PostContentsToHTML.js';

export const EmailPreview = ({ emailBlast }: { emailBlast?: EmailBlast | null }) => {
	return (
		<div className={styles.preview}>
			<div>
				<div>
					<div>
						<b>Subject:</b> {emailBlast?.subject}
					</div>
					<div className={styles.previewBody}>
						<PostContentsToHTML>{emailBlast?.body || ''}</PostContentsToHTML>
					</div>
				</div>
			</div>
		</div>
	);
};
